/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import makeStyles from "@material-ui/styles/makeStyles";

import {
  List,
  TextField,
  FunctionField,
  Datagrid,
  EditButton,
  CreateButton,
  DeleteButton,
  Filter,
  SelectInput,
  FilterButton,
  ShowButton
} from "jazasoft";

import HistoryButton from "../../../components/LibraryHistoryButton";

import { inputOptions, isEmpty, listFromCsv } from "../../../utils/helpers";
import useUnit from "../../../hooks/useUnit";
import useEntityPrivilege from "../../../hooks/useEntityPrivilege";
import SettingKeys from "../../../utils/SettingKeys";
import { useSetting } from "../../../hooks";
import { ProductFields } from "../../../utils/entityFields";
import { Role } from "../../../utils/types";

const choicesEnabled = [
  { id: "true", name: "Active" },
  { id: "false", name: "Not Active" }
];

const useStyles = makeStyles(theme => ({
  button: {
    width: theme.spacing(12)
  },
  buttonDelete: {
    width: theme.spacing(16)
  },
  container: {
    margin: theme.spacing(3),
    padding: theme.spacing(3)
  },
  buttonHistory: {
    width: theme.spacing(1)
  }
}));

const Product = props => {
  const classes = useStyles();
  const { roles = [], i18nKey, resource } = props;
  const fields = useSetting(SettingKeys.ENTITY_FIELDS, resource);

  const { disableCreate, disableEdit, disableDelete } = useEntityPrivilege("product");
  const { allUnitList } = useUnit();
  const unitChoices = [{ id: "all", name: "All Units" }, ...allUnitList.map(({ unitId, name }) => ({ id: unitId, name }))];

  return (
    <List
      actions={({ basePath, roles = [] }) => (
        <div>
          {(roles?.includes(Role.MASTER) || roles?.includes(Role.SUPER_USER)) && !disableCreate && (
            <CreateButton basePath={basePath} showLabel={false} />
          )}
          <FilterButton showLabel={false} />
        </div>
      )}
      filters={
        <Filter>
          {allUnitList?.length > 1 && <SelectInput source="unitIds" i18nKey={i18nKey} choices={unitChoices} {...inputOptions(12)} />}
          <SelectInput source="enabled" i18nKey={i18nKey} choices={choicesEnabled} {...inputOptions(12)} />
        </Filter>
      }
      parse={({ unitIds, ...rest }) => ({ ...rest, unitIds: unitIds === "all" ? unitIds : !isEmpty(unitIds) ? `*${unitIds}*` : undefined })}
      {...props}>
      <Datagrid>
        {fields.includes(ProductFields.NAME) && <TextField source="name" />}
        {fields.includes(ProductFields.BUNDLE_PARTS) && <TextField source="bundleParts" />}
        {fields.includes(ProductFields.REPLACEMENT_PANELS) && <TextField source="replacementPanels" />}
        {allUnitList?.length > 1 && (
          <FunctionField
            source="unitIds"
            label="Units"
            render={record =>
              allUnitList
                .filter(u => listFromCsv(record?.unitIds).includes(u.unitId))
                .map(u => u.name)
                .join(", ")
            }
          />
        )}
        <HistoryButton cellClassName={classes.buttonHistory} i18nKey={props.i18nKey} />
        <ShowButton cellClassName={classes.button} />
        {(roles?.includes(Role.MASTER) || roles?.includes(Role.SUPER_USER)) && !disableEdit && <EditButton cellClassName={classes.button} />}
        {(roles?.includes(Role.MASTER) || roles?.includes(Role.SUPER_USER)) && !disableDelete && (
          <DeleteButton cellClassName={classes.buttonDelete} />
        )}
      </Datagrid>
    </List>
  );
};

export default Product;
